"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "5", cy: "12", r: "2.5" },
        React.createElement("animate", { accumulate: "none", additive: "replace", attributeName: "fill-opacity", begin: "0ms", calcMode: "linear", dur: "1s", fill: "remove", repeatCount: "indefinite", restart: "always", values: "1;.2;1" })),
    React.createElement("circle", { cx: "12", cy: "12", r: "2.5" },
        React.createElement("animate", { accumulate: "none", additive: "replace", attributeName: "fill-opacity", begin: "100ms", calcMode: "linear", dur: "1s", fill: "remove", repeatCount: "indefinite", restart: "always", values: "1;.2;1" })),
    React.createElement("circle", { cx: "19", cy: "12", r: "2.5" },
        React.createElement("animate", { accumulate: "none", additive: "replace", attributeName: "fill-opacity", begin: "300ms", calcMode: "linear", dur: "1s", fill: "remove", repeatCount: "indefinite", restart: "always", values: "1;.2;1" }))), "LoadingDots");
//# sourceMappingURL=LoadingDots.js.map